import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FeatureRow } from '../../../../widgets/feature-row/feature-row';

@Component({
  selector: 'app-assets-tracking-software',
  templateUrl: './page.html',
  styleUrl: './page.scss',
  standalone: true,
  imports: [RouterLink, FeatureHero, FeatureRow],
})
export class AssetTracking {
  overviewParagraphs = [
    "Asset tracking is used to track, monitor, and manage all assets in the enterprise. It makes sure that organizations can track assets, such as equipment, tools, and inventory. Asset tracking also helps understand where their assets are located, how they are being used, and how they perform over time.",
    "With asset tracking, it is easy to optimize asset utilization and reduce the costs associated with asset management. In the process, this also prevents asset loss and theft."
  ];

  solutionParagraphs = [
    "Infraon's asset tracking solution offers a single place for monitoring and managing physical assets with real-time accuracy. With a user-friendly interface and analytics capabilities, it enables organizations to maintain accurate records of asset locations, conditions, and utilization.",
    "Infraon's asset tracking solution includes features for tracking asset location, condition, and history using barcode, QR code or RFID. Furthermore, it also sends alerts to notify you when an asset is moved or used and to track asset history.",
    "You can seamlessly reduce manual workflows and human errors while enhancing employee productivity."
  ];

  otherFeaturesItems = [
    'Customizable Dashboard',
    'User and Role Management',
    'Audit Trails',
    'Mobile Accessibility'
  ];

  improvedMgmtParagraph = ["Leverage features, such as asset tagging, monitoring, and maintenance. Make sure assets are always in good working condition."];
  increasedVisibilityParagraph = ["Get a complete view of assets - where they are located, who is using them, and how they are being used. Ensure assets are being used efficiently."];
  automatedComplianceParagraph = ["Automatically verify adherence to regulations. Set scan-based audits and easily find out an asset's location, assigned user, expiry date, etc."];
  reducedCostsParagraph = ["Reduce the costs associated with asset management, such as the costs of lost or stolen assets."];
  enhancedSecurityParagraph = ["Get a complete view of assets to quickly respond to security breaches and prevent threats."];
  betterDecisionParagraph = ["Make informed decisions about assets by understanding the cost, location, and utilization."];

  bestPracticesParagraph = ["Infraon's IT asset management solution is rooted in industry best practices such as:"];
  bestPracticesItems = [
    'Advanced data analytics to gain insights into IT asset performance, usage, etc.',
    'Simplified identification, tracking, and reporting of IT assets',
    'Integrated approach to tracking IT asset costs, depreciation, and ROI',
    'Risk assessment to detect vulnerabilities and threats to the IT asset ecosystem',
    'Tagging and tracking technologies like RFID to streamline inventory management',
    'Change management procedures to manage modifications to IT assets'
  ];

  benefitsParagraph = ["By deploying Infraon's IT asset management solution, you can enjoy benefits like:"];
  benefitsItems = [
    'Easier to incorporate green IT practices in asset management',
    'Seamless collaboration between IT, finance, procurement, and other departments',
    'Cost efficiency by accurately tracking and managing IT assets',
    'Streamline IT operations through automated processes and centralized asset management',
    'Reduced risk of legal penalties and enhanced data governance'
  ];

  constructor() {}

}